import i18next from "i18next";
import React, { useCallback, useContext, useEffect, useState } from "react";

import { Context } from "../../../../states/Store";
import useStyles from "../../../../style/js-style/containers/thirdparties/sheet/ThirdpartyDataHubStyle";

import { formatDataHubDate, formatDate, hasOption } from "services/common/Utils";
import EAIcon from "components/common/EAIcon";
import DataHubBlock from "./DataHubBlock";
import clsx from "clsx";
import _ from "lodash";
import DataHubDetailDialog from "./DataHubDetailDialog";
import EAButton from "components/common/EAButton";
import { Typography } from "@mui/material";
import { getDataHubSources, getDrealLcFields, getDrealLtiFields } from "services/common/DataHubUtils";
import { getThirdPartyDataHub } from "services/edge/ThirdpartyService";
import { ERROR, Subscription } from "services/common/Constants";


function DataHubPanel({ thirdPartyId, dataType, setExpanded }) {
  const { classes } = useStyles();
  const [state, dispatch] = useContext(Context);
  const [dataHubDetail, setdataHubDetail] = useState();
  const [updateDate, setUpdateDate] = useState();
  const [isDetailDialogOpen, setIsDetailDialogOpen] = useState(false);
  const [nbBlocks, setNbBlocks] = useState(0);
  const [currentSource, setCurrentSource]= useState();
  const [thirdpartyDataHub, setThirdpartyDataHub] = useState();

  const removeEmptyDrealFields = (sourceId, data) => {
    if (!data?.values) return;

    const ltiFields = getDrealLtiFields(sourceId);
    const lcFields = getDrealLcFields(sourceId);

    const numeroLti = data?.values?.find(
      (item) => item.fieldName === 'Numero_LTI'
    );
    if (numeroLti && numeroLti.value === '') {
      data.values = data.values.filter(
        (item) => !ltiFields.includes(item.fieldName)
      );
    }

    const numeroLc = data?.values?.find(
      (item) => item.fieldName === 'Numero_LC'
    );
    if (numeroLc && numeroLc.value === '') {
      data.values = data.values.filter(
        (item) => !lcFields.includes(item.fieldName)
      );
    }
  };

  const addDrealLicenseLines = (data, certDataMapDetail) => {
    // It should be in this order
    const numeroLc = data?.values?.find(
      (item) => item.fieldName === 'Numero_LC'
    );
    if (numeroLc && numeroLc.value !== '') {
      const lcIndex = data?.values?.findIndex(
        (item) => item.fieldName === 'Numero_LC'
      );
      if (lcIndex !== -1) {
        certDataMapDetail.splice(lcIndex, 0, { label: '', value: '' });
        certDataMapDetail.splice(lcIndex + 1, 0, {
          label: i18next.t(
            `thirdpartySheet.dataHub.details.license`
          ),
          value: 'LC (Licence Communautaire)',
        });
      }
    }

    const numeroLti = data?.values?.find(
      (item) => item.fieldName === 'Numero_LTI'
    );
    if (numeroLti && numeroLti.value !== '') {
      certDataMapDetail.unshift({
        label: i18next.t(
          `thirdpartySheet.dataHub.details.license`
        ),
        value: 'LTI (Licence Transport Intérieur)',
      });
    }
  };

  useEffect(() => {
    const dataHubSubscription = getDataHubSources().filter(s => s.id === dataType)[0];
    setCurrentSource(dataHubSubscription);
  }, [dataType]);

  const fetchThirdPartyDataHub = useCallback(() => {
      async function getDataHub(sourceId) {
        try {
          const result = await getThirdPartyDataHub(
            state.account.id,
            thirdPartyId,
            sourceId,
            dispatch
          );
          setThirdpartyDataHub(result.content);
  
        } catch (error) {
          console.error(error);
          dispatch({
            type: "ALERT",
            alert: { type: ERROR, msg: "DATA_SOURCE_NOT_FOUND" },
          });
        }
      }
  
      if (state.account && currentSource) {
        getDataHub(currentSource.subscription.sourceId);
      }
    }, [dispatch, state.account, thirdPartyId, currentSource]);

  useEffect(() => {
    if (hasOption(state.accounts, state.account.id, Subscription.DATA_HUB)) {
      fetchThirdPartyDataHub();
    }
  }, [fetchThirdPartyDataHub, state.accounts, state.account.id]);

  useEffect(() => {
    if (currentSource 
      && thirdpartyDataHub
      && hasOption(state.accounts, state.account.id, "DATA_HUB")
      && hasOption(state.accounts, state.account.id, currentSource.subscription)) {
      let content = thirdpartyDataHub?.[currentSource.id];
      let certData = content?.data;
      const certDataMapDetail = [];

      for (let data of certData) {
        removeEmptyDrealFields(currentSource.id, data);
        setUpdateDate(data?.creationDate);
        for (let i = 0; i < data?.values?.length; i++) {
          let item = data?.values[i];
          const label = item.label[state.lang] !== undefined ? item.label[state.lang] : item.label['en']
          if (item.fieldType === "BOOLEAN") {
            certDataMapDetail.push({ label: label, value: item.value.toLowerCase() === 'true' ? i18next.t("yes") : i18next.t("no") });
          } else if (item.fieldType === "DATE") {
            certDataMapDetail.push({ label: label, value: item.value === 'NA' ? item.value : formatDataHubDate(item.value) });
          } else {
            certDataMapDetail.push({ label: label, value: item.value });
          }
        }
        addDrealLicenseLines(data, certDataMapDetail);
        certDataMapDetail.push({ label: "", value: "" })
      }
      setNbBlocks(certData.length);
      setdataHubDetail(certDataMapDetail);
    }
  }, [thirdpartyDataHub, currentSource, state.accounts, state.account, state.lang]);

  useEffect(() => {
    setExpanded(!_.isEmpty(dataHubDetail));
    // eslint-disable-next-line
  }, [dataHubDetail]);

  return (
    <>
      {!_.isEmpty(dataHubDetail) ? (
        <div className={classes.scrollablePanel}>
          <div style={{ width: "65%"}}>
            {dataHubDetail?.map((item, index) => {
              return (
                <DataHubBlock label={item?.label} value={item?.value} key={index} />
              )
            })}
          </div>
          <div style={{ display: "flex", width: "35%", justifyContent: 'flex-end' }}>
            <Typography variant="h6" className={clsx(classes.blocTitle, classes.dateTitle)}>
              <EAIcon icon={"calendar_red"} className={classes.iconSmall} />
              <span className={classes.titleRed}>{i18next.t("thirdpartySheet.dataHub.updateDate")} : </span>
              <span className={classes.titleGrey}> {formatDate(updateDate)} </span>
            </Typography>
            {nbBlocks > 1 && (
              <EAButton
                onClick={() => setIsDetailDialogOpen(true)}
                content={i18next.t("thirdpartySheet.dataHub.seeDetail")}
                size={"small"}
                colorVariant={"primaryLight"}
                customStyle={{ height: "32px", boxShadow: "none" }}
              />
            )}
          </div>
        </div>
      ) : (
        <div className={classes.rootNoData}>
          <EAIcon icon="search_off" />
          <span className={classes.noDataText}>{i18next.t('thirdpartySheet.dataHub.noData')}</span>
        </div>
      )}

      {/* PopUp : detail */}
      {isDetailDialogOpen && (
        <DataHubDetailDialog
          dataHubData={dataHubDetail}
          sourceName={dataType}
          isOpen={isDetailDialogOpen}
          onClose={() => setIsDetailDialogOpen(false)}
        />
      )}
    </>
  );
}

export default DataHubPanel;
